export const PROPERTY_ARI_STATUS_OCCUPATION_CODE = { IGNORED_FILTER: "IGNORED_FILTER" };
export const ENGINE_VERSION = { "21": "21", "17": "17" };
